import { render, staticRenderFns } from "./hyrox-fitnesstype-overlay.component.vue?vue&type=template&id=b3aeca1c"
import script from "./hyrox-fitnesstype-overlay.component.ts?vue&type=script&lang=ts&external"
export * from "./hyrox-fitnesstype-overlay.component.ts?vue&type=script&lang=ts&external"
import style0 from "./hyrox-fitnesstype-overlay.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports